module.exports = __webpack_public_path__ + "static/media/hamster.3b95fa85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/hamster.svg
// module id = 63
// module chunks = 0